import React from 'react';
import { actsData } from '../../data/knowledgeBank/actsData';
import { FiBookOpen, FiExternalLink } from 'react-icons/fi';

export default function Acts() {
  return (
    <div className="page-wrapper">
      <div className="page-hero">
        <h1>Acts</h1>
        <p>Statutory acts and sections directory</p>
      </div>

      <main style={{ padding: '60px 0', background: 'var(--off-white)' }}>
        <div className="container">
          {/* Acts List */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            {actsData.map((act) => (
              <div
                key={act.id}
                style={{
                  background: 'var(--white)',
                  borderLeft: '4px solid var(--primary)',
                  borderTop: '1px solid var(--gray-200)',
                  borderRight: '1px solid var(--gray-200)',
                  borderBottom: '1px solid var(--gray-200)',
                  borderRadius: 'var(--radius-sm)',
                  padding: '24px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  gap: '24px',
                  flexWrap: 'wrap',
                  boxShadow: 'var(--shadow-sm)'
                }}
              >
                <div style={{ flex: '1 1 500px' }}>
                  <h3 
                    style={{ 
                      fontSize: '1.25rem', 
                      color: 'var(--primary-dark)', 
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 700,
                      marginBottom: '8px'
                    }}
                  >
                    {act.name}
                  </h3>
                  <p style={{ color: 'var(--text-muted)', fontSize: '0.95rem', lineHeight: '1.5' }}>
                    {act.description}
                  </p>
                </div>

                <a
                  href={act.originalUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '10px 20px',
                    fontSize: '0.9rem',
                    borderRadius: 'var(--radius-sm)',
                    whiteSpace: 'nowrap'
                  }}
                >
                  <FiBookOpen size={16} /> Read Act <FiExternalLink size={13} />
                </a>
              </div>
            ))}

            {actsData.length === 0 && (
              <div style={{ textAlign: 'center', padding: '40px', color: 'var(--text-muted)' }}>
                No acts found.
              </div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
}
